declare global {
  interface PromiseConstructor {
    delay(ms: number): Promise<void>;
  }
}

Promise.delay =
  async function (ms: number) {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  };

export { };
